/**
 * Create a form field for the state
 * 
 * @param {String} value - The default value of the state.
 * @param {Array} length - An array containing the length of the field. Eg: [min, max]
 */
export default (value, length, type = "text", options = {}) => {
        const state = {
                value: value,
                min: length[0],
                max: length[1],
                hasError: false,
                errorMessage: '',
                type: type,
                required: true,
                ...options
        };

        return state;
};